import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { defineComponent, reactive, ref, onMounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import * as echarts from "echarts";
export default defineComponent({
  name: "Portrait",
  components: {
    Head: Head
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; // 图片路径前缀


    var baseUrl = process.env.VUE_APP_BASE_URL; // 路由

    var router = useRouter(); // 获取个人资料

    var Data = reactive({
      organizationaLife: {},
      detail: {},
      options: {
        color: ['#dd6461'],
        radar: {
          radius: 130,
          splitNumber: 4,
          indicator: [],
          axisLabel: {
            show: true
          },
          axisName: {
            color: '#000000'
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: '#e1e0e0'
            }
          },
          splitArea: {
            show: false,
            color: '#e1e0e0'
          },
          splitLine: {
            lineStyle: {
              color: '#e1e0e0'
            }
          }
        },
        series: [{
          type: 'radar',
          // symbol: 'none',
          data: [{
            value: [],
            label: {
              show: true
            },
            areaStyle: {
              color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [{
                color: 'rgb(255, 191, 191)',
                offset: 0
              }])
            }
          }]
        }]
      }
    }); // 学习教育和组织生活相关信息

    var myData = ref({}); //挂载eCharts

    var myChart = ref([]);

    var getMountEcherts = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var eChart;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (myChart.value.length == 0) {
                  eChart = document.getElementById("eCharts");

                  if (eChart) {
                    myChart.value.push(echarts.init(eChart));
                  }
                }

                myChart.value[0].setOption(Data.options);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getMountEcherts() {
        return _ref.apply(this, arguments);
      };
    }();

    function getDetail() {
      return _getDetail.apply(this, arguments);
    } // 查看图标


    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$globalProperti2, data, code, ref;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getInformation"]();

              case 2:
                _yield$globalProperti2 = _context4.sent;
                data = _yield$globalProperti2.data;
                code = _yield$globalProperti2.code;

                if (code == 0) {
                  Object.assign(Data.detail, data);
                } // 获取学习教育和组织生活相关信息


                _context4.next = 8;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMyData"]();

              case 8:
                ref = _context4.sent;

                if (ref.code == 0) {
                  myData.value = ref.data;
                }

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _getDetail.apply(this, arguments);
    }

    var getChart = function getChart(apiName, type) {
      router.push({
        name: "chart",
        query: {
          apiName: apiName,
          type: type
        }
      });
    };

    var compare = function compare(obj1, obj2) {
      var val1 = obj1.categoryId;
      var val2 = obj2.categoryId;

      if (val1 < val2) {
        return -1;
      } else if (val1 > val2) {
        return 1;
      } else {
        return 0;
      }
    }; // 数据调整


    function adjust(arr) {
      var arr1 = arr.filter(function (item, index) {
        return index != 0;
      });
      return [arr[0]].concat(_toConsumableArray(arr1.reverse()));
    }

    var getEchartsData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var nameArr, list, _yield$globalProperti, data, code;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Data.options.series[0].data[0].value = [];
                Data.options.radar.indicator = [];
                nameArr = [];
                _context2.next = 5;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getCategoryList"]();

              case 5:
                list = _context2.sent;

                if (list.code == 0) {
                  list.data.sort(compare).forEach(function (item) {
                    nameArr.push(item.category);
                  });
                  nameArr.push("党建考核"); // fieldList.value=list.data
                } else {
                  ElMessage.error("保存失败");
                }

                _context2.next = 9;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getScore"]();

              case 9:
                _yield$globalProperti = _context2.sent;
                data = _yield$globalProperti.data;
                code = _yield$globalProperti.code;

                if (code == 0) {
                  data.radarMax.forEach(function (item, index) {
                    Data.options.radar.indicator.push({
                      name: nameArr[index],
                      max: 100
                    });

                    if (item == 0) {
                      Data.options.series[0].data[0].value.push(100);
                    } else {
                      Data.options.series[0].data[0].value.push(Math.round(data.userData[index] / item * 100));
                    }
                  });
                  Data.options.radar.indicator = adjust(Data.options.radar.indicator);
                  Data.options.series[0].data[0].value = adjust(Data.options.series[0].data[0].value);
                }

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getEchartsData() {
        return _ref2.apply(this, arguments);
      };
    }();

    onMounted(function () {
      nextTick(function () {
        getList();
      });
    });

    var getList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getDetail();

              case 2:
                _context3.next = 4;
                return getEchartsData();

              case 4:
                _context3.next = 6;
                return getMountEcherts();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getList() {
        return _ref3.apply(this, arguments);
      };
    }();

    return {
      Data: Data,
      baseUrl: baseUrl,
      myData: myData,
      getChart: getChart
    };
  }
});